import React, { useState } from 'react';
import _ from 'lodash';
import { PayloadStates } from '@lore/utils';
import moment from 'moment-timezone';
import ChartLoader from '../../states/_charts/ChartLoader';
import LineChart from '../../states/_charts/LineChart';
import colors from 'tailwindcss/colors';
import useInvitations from './_hooks/useInvitations';

export default function InvitationsByMonth(props) {
  const { state, network, timestamps, empty, schoolStart } = props;

  const [currentTimestamp] = useState(moment().toISOString());

  const educators = timestamps.map(function(timestamp, index) {
    if (moment(currentTimestamp).diff(timestamp.start) < 0) {
      return {
        ...timestamp,
        results: {
          created: empty(),
          yes: empty(),
          maybe: empty(),
          pending: empty(),
          no: empty()
        }
      }
    }

    return {
      ...timestamp,
      results: {
        created: useInvitations(state, network, timestamp.start, timestamp.end),
        yes: useInvitations(state, network, timestamp.start, timestamp.end, {
          response: 'Yes'
        }),
        maybe: useInvitations(state, network, timestamp.start, timestamp.end, {
          response: 'Maybe'
        }),
        pending: useInvitations(state, network, timestamp.start, timestamp.end, {
          response: 'Pending'
        }),
        no: useInvitations(state, network, timestamp.start, timestamp.end, {
          response: 'No'
        })
      }
    }
  });

  const loading = _.reduce(educators, function(result, educator) {
    return (
      result ||
      educator.results.created.state === PayloadStates.FETCHING ||
      educator.results.yes.state === PayloadStates.FETCHING ||
      educator.results.maybe.state === PayloadStates.FETCHING ||
      educator.results.pending.state === PayloadStates.FETCHING ||
      educator.results.no.state === PayloadStates.FETCHING
    );
  }, false)

  if (loading) {
    return (
      <ChartLoader
        title="Event invitation breakdown"
        subtitle="Over school year"
      />
    );
  }

  const series = [
    {
      name: 'Sent',
      data: educators.map(e => e.results.created.meta.totalCount)
    },
    {
      name: 'Yes',
      data: educators.map(e => e.results.yes.meta.totalCount)
    },
    {
      name: 'Maybe',
      data: educators.map(e => e.results.maybe.meta.totalCount)
    },
    {
      name: 'Pending',
      data: educators.map(e => e.results.pending.meta.totalCount)
    },
    {
      name: 'No',
      data: educators.map(e => e.results.no.meta.totalCount)
    }
  ];

  return (
    <LineChart
      title="Event invitation breakdown"
      subtitle="Over school year"
      labels={educators.map(e => e.label)}
      series={series}
      colors={[
        colors.neutral['400'],
        colors.emerald['400'],
        colors.blue['400'],
        colors.yellow['400'],
        colors.red['400']
      ]}
    />
  );
}
